/**
 * Context + hook for signing in without leaving the page. Kept apart from
 * `SignInProvider` so that file exports only components (react-refresh).
 *
 * `openSignIn(onSuccess?)` opens the one `LoginModal` mounted by
 * `SignInProvider` over whatever page is showing. On success `onSuccess` runs
 * (the action that needed an account continues) and the modal closes; the
 * page itself re-renders with its signed-in content. Closing the modal
 * without signing in does nothing else: the person stays where they were and
 * `onSuccess` is dropped.
 */

import { createContext, useContext } from 'react';

export interface SignInContextValue {
  openSignIn: (onSuccess?: () => void) => void;
}

export const SignInContext = createContext<SignInContextValue | null>(null);

export function useSignIn(): SignInContextValue {
  const value = useContext(SignInContext);
  if (!value) throw new Error('useSignIn must be used inside <SignInProvider>');
  return value;
}
